import { createRoot } from 'react-dom/client';

import './upgrade.scss';

document.addEventListener('DOMContentLoaded', () => {
    const upgradePageEl = document.getElementById('apbUpgradePage');

    createRoot(upgradePageEl).render(<UpgradePageContent />);
});

const UpgradePageContent = () => {
    return <div className='fsUpgradePrice'>
        <iframe src="https://wp.freemius.com/pricing/?plugin_id=14262&amp;plugin_public_key=pk_87f141adce326dfb96ba4e12d8a36&amp;plugin_version=1.12.1&amp;s_ctx_type=install&amp;s_ctx_id=13628791&amp;s_ctx_ts=1700391158&amp;s_ctx_secure=eb9a75f4e08238b0503308d46009a65d&amp;post_type=apb&amp;page=advanced-post-block-pricing&amp;next=http%3A%2F%2Flocalhost%2Fdevelopment%2Fwp-admin%2Fedit.php%3Fpost_type%3Dapb%26fs_action%3Dadvanced-post-block_sync_license%26page%3Dadvanced-post-block-account&amp;billing_cycle=annual&amp;is_network_admin=false&amp;currency=usd#http%3A%2F%2Flocalhost%2Fdevelopment%2Fwp-admin%2Fedit.php%3Fpost_type%3Dapb%26page%3Dadvanced-post-block-pricing" width="100%" height="800px" scrolling="no" frameBorder="0" style={{ background: 'transparent', width: '1px', minWidth: '100%', height: '2763px' }}></iframe>
    </div>
}